import React, { useRef } from "react";
import AddressAndCoordinates from "./AddressAndCoordinates";
import DropdownTable from "../../components/DropdownTable";
import { hasGazobetonProduct } from "./deliveryMethodsHelpers";

import "../../theme/redesign/tokens.css";
import "../../theme/redesign/section.css";
import "../../theme/redesign/delivery.css";

// Регионы для самовывоза. Хранятся в одном месте — используются и в чекбоксе, и в селекте.
const regions = [
  { value: "СПБ", label: "Санкт-Петербург", coordinates: { lat: 59.9343, lng: 30.3351 } },
  { value: "МСК", label: "Москва", coordinates: { lat: 55.7558, lng: 37.6173 } },
  { value: "КРД", label: "Краснодар", coordinates: { lat: 45.0355, lng: 38.9753 } },
];

const payments = [
  { value: "cash", label: "Наличные" },
  { value: "card", label: "Безналичный расчет" },
];

function Information({
  setSelfPickUp,
  selfPickUp,
  paymentMethod,
  setPaymentMethod,
  addressAndCoordinates,
  setAddressAndCoordinates,
  dealId,
  locationFromDeal,
  selectedRegion,
  setSelectedRegion,
  products,
  addressValidationError,
  setAddressValidationError,
}) {
  const addressAndCoordinatesRef = useRef(null);

  const handleCheckChange = (event) => {
    const isChecked = event.target.checked;
    setSelfPickUp(isChecked);

    if (isChecked) {
      const selectedRegionData = regions.find((region) => region.value === selectedRegion) || regions[0];
      setAddressAndCoordinates({
        address: selectedRegionData.label,
        coordinates: {
          latitude: parseFloat(selectedRegionData.coordinates.lat),
          longitude: parseFloat(selectedRegionData.coordinates.lng),
        },
      });
    } else if (dealId && locationFromDeal) {
      setAddressAndCoordinates({
        address: locationFromDeal.address,
        coordinates: {
          latitude: parseFloat(locationFromDeal.coordinates.latitude),
          longitude: parseFloat(locationFromDeal.coordinates.longitude),
        },
      });
    } else {
      setAddressAndCoordinates({
        address: "Санкт-Петербург",
        coordinates: {
          latitude: 59.9343,
          longitude: 30.3351,
        },
      });
    }
  };

  const handlePaymentChange = (value) => {
    setPaymentMethod(value);
  };

  const handleRegionChange = (regionValue) => {
    setSelectedRegion(regionValue);
    const selectedRegionData = regions.find((region) => region.value === regionValue);

    if (!selectedRegionData) {
      return;
    }

    setAddressAndCoordinates({
      address: selectedRegionData.label,
      coordinates: {
        latitude: parseFloat(selectedRegionData.coordinates.lat),
        longitude: parseFloat(selectedRegionData.coordinates.lng),
      },
    });

    if (addressAndCoordinatesRef.current) {
      const coordinatesString = `${selectedRegionData.coordinates.lat}, ${selectedRegionData.coordinates.lng}`;
      addressAndCoordinatesRef.current.setInputValue(coordinatesString);
      addressAndCoordinatesRef.current.convertData();
    }
  };

  const isGazobeton = hasGazobetonProduct(products, selectedRegion);

  return (
    <section className="rd-section">
      {/* eslint-disable-next-line jsx-a11y/alt-text */}
      <img src="/cat-girl-peek.png" className="cg-catgirl--peek-in-section" alt="" draggable="false" />
      <div className="rd-sec-head">
        <h2>
          Доставка и&nbsp;оплата
          {isGazobeton && <small>режим газобетон</small>}
        </h2>
      </div>

      <div className="rd-delivery">
        {/* Колонка 1 — регион (самовывоз) или адрес доставки */}
        <div className="rd-addr">
          <span className="rd-delivery__label">
            {selfPickUp ? "Выберите регион" : "Адрес и координаты"}
          </span>
          <div className="rd-addr__slot-wrap">
            {selfPickUp ? (
              <DropdownTable
                id="region-select"
                options={regions}
                selectedValue={selectedRegion}
                onChange={handleRegionChange}
                compact
              />
            ) : (
              <AddressAndCoordinates
                ref={addressAndCoordinatesRef}
                addressAndCoordinates={addressAndCoordinates}
                setAddressAndCoordinates={setAddressAndCoordinates}
                setSelfPickUp={setSelfPickUp}
                dealId={dealId}
                locationFromDeal={locationFromDeal}
                selectedRegion={selectedRegion}
                addressValidationError={addressValidationError}
                setAddressValidationError={setAddressValidationError}
              />
            )}
          </div>
        </div>

        {/* Колонка 2 — форма оплаты */}
        <div className="rd-pay">
          <span className="rd-delivery__label">Форма оплаты</span>
          <div className="rd-pay__radios" role="radiogroup" aria-label="Форма оплаты">
            {payments.map((p) => (
              <label key={p.value} className="rd-pay__radio">
                <input
                  type="radio"
                  name="rd-payment"
                  className="rd-pay__radio-native"
                  value={p.value}
                  checked={paymentMethod === p.value}
                  onChange={() => handlePaymentChange(p.value)}
                />
                <span className="rd-pay__dot" aria-hidden="true" />
                <span>{p.label}</span>
              </label>
            ))}
          </div>
        </div>

        {/* Колонка 3 — чекбокс «Самовывоз» (теперь справа) */}
        <label className="rd-check">
          <input
            type="checkbox"
            className="rd-check__native"
            checked={selfPickUp}
            onChange={handleCheckChange}
          />
          <span className="rd-check__box" aria-hidden="true" />
          <span>Самовывоз</span>
        </label>
      </div>
    </section>
  );
}

export default Information;
